export default __webpack_public_path__ + "static/media/secure-lock.2318c992.svg";